import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { useCreateZZ } from "../../../../../components/WMS/PurchaseOrders/useCreateZZ"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

export const Route = createFileRoute(
  "/_layout/WMS/documents/purchase-orders/new",
)({
  component: NewPurchaseOrderRoute,
})

function NewPurchaseOrderRoute() {
  const navigate = useNavigate()
  const { createZZ, isCreating, isResolvingWarehouses, canCreate } =
    useCreateZZ()
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    startedRef.current = true
    void createZZ()
  }, [canCreate, createZZ, isResolvingWarehouses])

  const handleCancel = () =>
    navigate({
      to: "/WMS/documents/document-list",
      search: { page: 1, page_size: 50 },
    })

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument ZZ"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu ZZ..."
      idleLabel="Przygotowywanie edycji dokumentu ZZ..."
    />
  )
}
